import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full mt-4" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.src,
        style: _normalizeStyle({
          ...(_ctx.width ? { width: _ctx.width } : {}),
          ...(_ctx.height ? { height: _ctx.height } : {}),
        }),
        class: "translate-z-0 w-full h-full m-auto",
        alt: ""
      }, null, 12, _hoisted_3)
    ])
  ]))
}